import React, { forwardRef } from "react";
import { makeStyles } from '@material-ui/styles';

import I18n from "../../../../../base/i18n.js.jsx";

import noPhoto  from "../../resources/images/managers/no-photo.png";

import IcSmallPhone from "../../../../../resources/icons/ic_small_phone.js";

import ButtonLink from "../../../../../base/links/button_link.js";

import { compose } from 'redux';
import withWindowResizeHandler from "../../../../../hocs/with_window_resize_handler.js";

const blockStyles = makeStyles(theme => ({
  root: {
    padding: "10px 13px 10px",
    ['@media (max-width: 768px)']: {
      padding: "10px 4px 10px",
      width: "40vw",
      minWidth: "140px",
      maxWidth: "152px"
    },
  },
  content: {
    backgroundColor: theme.palette.white,
    borderRadius: "2px",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.14)",
  },
  image: {
    width: "100%",
    height: "auto",  
  },
  imageWrapper: {
    height: "288px",
    margin: "0px 0px 16px",
    overflow: "hidden",
    ['@media (max-width: 1200px)']: {
      height: "248px",
    },
    ['@media (max-width: 768px)']: {
      margin: "0px 0px 12px",
      height: "152px",
    },
  },
  cardBottom: {
    padding: "0px 24px 24px",
    textAlign: "center",
    ['@media (max-width: 768px)']: {
      padding: "0px 8px 10px",
    },
  },
  name: {
    display: "block",
    fontSize: "16px",
    marginBottom: "12px",
    whiteSpace: "pre-line",
    ['@media (max-width: 768px)']: {
      fontSize: "12px",
      lineHeight: "14px",
      marginBottom: "6px",
    },
  },
  phone: {
    display: "flex",
    justifyItems: "center",
    textDecoration: "none",
    color: theme.palette.bronze,
    fontSize: "14px",
    marginBottom: "14px",
    ['@media (max-width: 768px)']: {
      fontSize: "11px",
      lineHeight: "18px",
      marginBottom: "8px",
    },
  },
  icPhone: {
    stroke: theme.palette.grayText,
    marginRight: "12px",
    ['@media (max-width: 768px)']: {
      marginRight: "0px",
      display: "none"
    },
  },
  phoneLink: {
    textDecoration: "none",
    color: theme.palette.grayText, 
    "&:hover": {
      textDecoration: "underline"
    }
  },
  spacing: {
    flexGrow: 1
  },
  contact: {
    display: "block",
    width: "100%",
    padding: '8px 20px',
    fontSize: "14px",
    ['@media (max-width: 768px)']: {
      padding: '4px 20px',
      fontSize: "10px",
    },
  }

}));

const ManagerCard = forwardRef((props, ref) => {
  const classes = blockStyles();
  const { manager: { name, mail, phone, image } } = props;

  return (
    <div className = { classes.root } >
      <div className = { classes.content } 
           ref = { ref } >
        <div className = { classes.imageWrapper }>
          <img src = { image ? image : noPhoto } 
               width = "250"
               height = "350"
               alt = { name }
               className = { classes.image } />
        </div>
        <div className = { classes.cardBottom } >
          <span className = { classes.name } >
            { name.replace(" ", "\r\n") }
          </span>
          <div className = { classes.phone } >
            <div className = { classes.spacing } />
            <IcSmallPhone className = { classes.icPhone } />
              <a className = { classes.phoneLink }
                 href = {`tel:${ phone }`}>
                  { phone }
              </a>
            <div className = { classes.spacing } />
          </div>
          <ButtonLink className = { classes.contact }
                      to = { `mailto:${mail}` } 
                      target = { "_blank" } >
            { I18n.t("action.contact_via_email") }
          </ButtonLink>
        </div>
      </div>
    </div>
  );
});

export default compose(withWindowResizeHandler)(ManagerCard);
